export enum ProjectStatus {
  ACTIVE,
  PENDING,
  ARCHIVED,
}
